module.exports = __webpack_public_path__ + "danone.png?8e6f027942db5611bf196f3beefde338";


//////////////////
// WEBPACK FOOTER
// ./src/assets/danone.png
// module id = 372
// module chunks = 0